import { FunctionComponent, useEffect, useRef } from 'react';
import moment, { Moment } from 'moment-timezone';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import clsx from 'clsx';
import styles from './HoursBooking.module.scss';

interface HoursBookingProps {
    dayMoment: Moment;
    slotTimes?: Array<string>;
    onSelectHour: (hours: string) => void;
}

export const HoursBooking: FunctionComponent<HoursBookingProps> = props => {
    const selectedRef = useRef<HTMLElement>(null);

    const createHours = () => {
        const midnight = moment().startOf('day');
        const hours = [midnight.format('LT').toLowerCase()];
        let dateAdded = moment().startOf('day');

        while (midnight.format('L') === dateAdded.format('L')) {
            const datePlus15Min = dateAdded.add(15, 'minutes');
            hours.push(datePlus15Min.format('LT').toLowerCase());
            dateAdded = datePlus15Min;
        }
        hours.pop();

        return hours;
    };

    useEffect(() => {
        selectedRef?.current?.scrollIntoView();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRef]);

    return (
        <OverlayScrollbarsComponent className={styles.container}>
            {createHours().map(hour => {
                const itemProps = hour === props.dayMoment.format('LT').toLowerCase() ? { ref: selectedRef } : {};
                return (
                    <span
                        key={hour}
                        className={clsx(styles.item, {
                            [styles.itemSelected]: hour === props.dayMoment.format('LT').toLowerCase(),
                            [styles.itemSlot]: props.slotTimes?.includes(hour)
                        })}
                        onClick={() => props.onSelectHour(hour)}
                        id={`booking_option_hour_${hour}`}
                        {...itemProps}
                    >
                        {hour}
                    </span>
                );
            })}
        </OverlayScrollbarsComponent>
    );
};

export default HoursBooking;
